import { useCallback, useEffect, useState } from 'react';
import type { VideoListItem } from '@ddp/shared';

import { apiFetch } from '../../api/client.js';

/**
 * Charge et rafraîchit la liste des vidéos de l'organisation active.
 *
 * `refresh` est exposé pour être rappelé après un téléversement : une vidéo tout juste finalisée
 * doit apparaître sans rechargement de page.
 */
export function useVideos() {
  const [videos, setVideos] = useState<VideoListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setError(null);
    try {
      const list = await apiFetch<VideoListItem[]>('/videos');
      setVideos(list);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Chargement des vidéos impossible');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { videos, loading, error, refresh };
}
